import { State } from '@meraki-internal/state';

interface IBodyConflictRequest {
    theirsHtml: string;
    resolve: (choice: 'mine' | 'theirs') => void;
}

// Holds the single in-flight "their note body" conflict (if any) and resolves a promise with the
// user's choice. Mirrors the AlertPresenter split: this is the IoC-injectable presenter; the
// globally-mounted NoteBodyConflictDrawer renders the modal from this state and calls choose().
export class NoteBodyConflictPresenter extends State<Record<string, never>> {
    constructor() {
        super({ });
    }

    private request?: IBodyConflictRequest;

    present = ({ theirsHtml }: { theirsHtml: string }): Promise<'mine' | 'theirs'> => {
        return new Promise<'mine' | 'theirs'>(resolve => {
            this.request = { theirsHtml, resolve };
            this.setState({ });
        });
    };

    getActiveTheirsHtml = (): string | undefined => {
        return this.request?.theirsHtml;
    };

    choose = (choice: 'mine' | 'theirs') => {
        const request = this.request;
        this.request = undefined;
        this.setState({ });
        if (request) {
            request.resolve(choice);
        }
    };
}
